import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import Cookies from 'universal-cookie';
import { ClockCircleOutlined } from '@ant-design/icons';
import { t, Trans } from '@lingui/macro';
import AppActions from 'bukku/redux/App/actions';
import AuthActions from 'bukku/redux/Auth/actions';
import { MomentFormatEnums } from '../../enums/MomentEnums';
import { SessionExpiredMessage } from '../../components/Message/SessionExpired.js';
import { CookieKey } from '../../enums/CookieKey';

dayjs.extend(isSameOrBefore);

/** DEPRECATED on 2 Feb 2023 to use ENG-1125 SessionExpiredModal  */
const {
    logout,
} = AuthActions;
const {
    toggleTimeoutBox,
} = AppActions;

const urlMode = process.env.REACT_APP_URL_MODE;
const urlDomain = process.env.REACT_APP_URL_DOMAIN;
const cookiePrefix = process.env.REACT_APP_COOKIE_PREFIX;

const REFRESH_SENSITIVITY_SECONDS = 1; // timer refresh every 1 minute
const TRIGGER_VISIBILITY_BELOW_MINUTE = 60; // will show in sidebar when <= 1 hour
const EXTEND_MINUTE = 60; // when click extend -> 1 hour
const MOMENT_TIME_UNIT = 'minutes';

export const cleanSessionTimeoutCookies = () => {
    const cookiesObj = new Cookies();
    // Options
    const options = {};
    options.path = '/';
    if (urlMode === 'subdomain')
        options.domain = `.${urlDomain}`;

    cookiesObj.remove(CookieKey.session_expiry, options);
};

export function SessionTimeoutTimer({
    hideText,
}) {
    const cookiesObj = new Cookies();
    const initialMinutesToExpiry = dayjs(cookiesObj
        .get(CookieKey.session_expiry))
        .diff(dayjs(), MOMENT_TIME_UNIT);
    const [minutesToExpiry, setMinutesToExpiry] = useState(initialMinutesToExpiry);

    // redux store state
    const dispatch = useDispatch();

    // https://stackoverflow.com/questions/53090432/react-hooks-right-way-to-clear-timeouts-and-intervals
    useEffect(() => {
        console.log('aaa session Timer component mount');

        const startIntervalCallback = () => {
            // console.log('aaa this.sessionExpiryCookie', cookiesObj.get(CookieKey.session_expiry));
            const expiry = dayjs(cookiesObj.get(CookieKey.session_expiry));
            const diff = expiry.diff(dayjs(), MOMENT_TIME_UNIT);

            // Every interval, refresh the display
            setMinutesToExpiry(diff);

            // console.log('aaa expiry, moment', {
            //     expiry: expiry.format(MomentFormatEnums.date_time),
            //     moment: Moment().format(MomentFormatEnums.date_time),
            //     isSameOrBefore: expiry.isSameOrBefore(Moment())});
            if (expiry.isSameOrBefore(dayjs())) {
                dispatch(logout());
                const expiredWarning = new SessionExpiredMessage();
                expiredWarning.show();
            }
        };

        const interval = setInterval(startIntervalCallback, REFRESH_SENSITIVITY_SECONDS * 1000);

        return () => {
            console.log('aaa session Timer component unmount');
            clearInterval(interval);
            // cleanTimeoutTimer();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const extendCookieExpiry = newExpiryMoment => {
        const accessToken = cookiesObj.get(`${cookiePrefix}at`);
        const subdomain = cookiesObj.get(`${cookiePrefix}cs`);

        // Options
        const options = {};
        options.expires = newExpiryMoment.toDate();
        options.path = '/';
        if (urlMode === 'subdomain')
            options.domain = `.${urlDomain}`;

        // Set cookies
        cookiesObj.set(`${cookiePrefix}at`, accessToken, options); //access token
        if (urlMode === 'single')
            cookiesObj.set(`${cookiePrefix}cs`, subdomain, options); // company subdomain
        cookiesObj.set(CookieKey.session_expiry,
            newExpiryMoment.format(MomentFormatEnums.date_time),
            options);
    };

    /**
     *
     * @param {number} amount
     * @param {string} unit moment supported units (eg: 'day', 'hour', 'minute', 'second')
     */
    const extendTime = (amount = 0, unit = 'minutes') => {
        const newExpiry = dayjs(cookiesObj.get(CookieKey.session_expiry)).add(amount, unit);
        setMinutesToExpiry(newExpiry.diff(dayjs(), MOMENT_TIME_UNIT));
        extendCookieExpiry(newExpiry);
    };

    console.log('aaa Render SessionTimeoutTimer');
    return (
        <SessionTimeoutTimerView
            minutesToExpiry={minutesToExpiry}
            visible={minutesToExpiry < TRIGGER_VISIBILITY_BELOW_MINUTE}
            hideText={hideText}
            extendTime={extendTime}
        />
    );
}

export function SessionTimeoutTimerView({ visible, hideText, extendTime, minutesToExpiry }) {
    // const minutesToExpiry = useSelector(state => state.SessionTimeout.minutesToExpiry);
    console.log('aaa SessionTimeoutTimerView', minutesToExpiry);
    const dispatch = useDispatch();

    useEffect(() => {
        if (visible)
            dispatch(toggleTimeoutBox(true));
        else
            dispatch(toggleTimeoutBox(false));
    }, [minutesToExpiry, visible, dispatch]);

    // console.log('aaa minutes to expiry', minutesToExpiry)
    // assumption: not more than 1 hour
    const displayTimer = `${(minutesToExpiry + 1) % (TRIGGER_VISIBILITY_BELOW_MINUTE + 1)} min`;

    return visible ? (
        <div
            className="isoLogoWrapper notice-box timeout"
            style={{ cursor: 'pointer' }}
            onClick={() => extendTime(EXTEND_MINUTE, 'minutes')}
        >
            <div className="notice-box-container">
                <p className="logo">
                    <ClockCircleOutlined className="exclaim" />
                </p>
                <div className={`text${hideText ? ' hidden' : ''}`}>
                    <strong style={{ fontSize: '13px', fontWeight: '500' }}>
                        <Trans>
                            Session Expiring in&nbsp;
                            <div style={{ fontSize: '15px', fontWeight: '900' }}>
                                {displayTimer}
                            </div>
                        </Trans>
                    </strong>
                    <div style={{ fontSize: '13px', marginTop: '4px' }}>
                        { t`Extend by ${EXTEND_MINUTE / 60} hour` }
                    </div>
                </div>
            </div>
        </div>
    ) : null;
}
